import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'reviews-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent {
  title = 'Reviews';

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang(globalThis.lang);
    this.translate.use(globalThis.locale);
  }
}
